import { render, staticRenderFns } from "./Registation.vue?vue&type=template&id=fb79a05e&scoped=true&lang=pug&"
import script from "./Registation.vue?vue&type=script&lang=js&"
export * from "./Registation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb79a05e",
  null
  
)

export default component.exports